import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function formTextZodSchema({ required, minLength, maxLength }: FormInputSchemaParams) {
	let schema = z.string();
	if (required) {
		schema = schema.min(1, { message: "required" });
	}
	if (typeof minLength === "number" && minLength > 0) {
		schema = schema.min(minLength, { message: "minLength" });
	}
	if (typeof maxLength === "number" && maxLength > 0) {
		schema = schema.max(maxLength, { message: "maxLength" });
	}
	return schema;
}
